export const plX = {
  footer: { privacy: "Polityka prywatności" },
  join: {
    ph: { region: "Region / Województwo" },
    privacy: "Przeczytałem/am i akceptuję",
    privacyLink: "Politykę prywatności",
    privacySuffix: ", w tym przetwarzanie moich danych poza moim krajem.",
  },
  database: {
    dirKicker: "Katalog publiczny",
    dirTitle: "Publikowane za zgodą",
    dirEmpty: "Brak publicznych wpisów. Katalog rośnie wraz z producentami i organizacjami, które wyrażą zgodę na publikację.",
  },
  verify: {
    checking: "Potwierdzanie rejestracji…",
    okTitle: "Rejestracja potwierdzona",
    okText: "Dziękujemy — Twoja rejestracja w World Rhubarb Association jest zakończona. E-mail powitalny z linkiem do ankiety bazy danych jest w drodze.",
    errTitle: "Link nieprawidłowy lub już użyty",
    errText: "Ten link potwierdzający jest nieprawidłowy lub został już użyty. Jeśli nie otrzymałeś e-maila potwierdzającego, zarejestruj się ponownie przez formularz.",
    home: "Wróć na stronę",
  },
  survey: {
    kicker: "Globalna baza danych rabarbaru",
    title: "Ankieta do bazy danych",
    intro: "Dziękujemy za rejestrację w World Rhubarb Association. Ta ankieta pomaga budować Globalną Bazę Danych Rabarbaru — zweryfikowany, oparty na zgodach rejestr światowej branży rabarbarowej. Odpowiadanie jest dobrowolne i nie wpływa na Twoją rejestrację.",
    verifyTitle: "Twoja rejestracja",
    refPh: "Numer referencyjny rejestracji (np. WRA-AB12CD34) *",
    emailPh: "E-mail rejestracyjny *",
    aboutTitle: "O Twoim gospodarstwie lub organizacji",
    farmPh: "Nazwa gospodarstwa / organizacji *",
    countryPh: "Kraj *",
    regionPh: "Region / Województwo",
    websitePh: "Strona www / media społecznościowe (opcjonalnie)",
    orgTypePh: "Typ organizacji *",
    orgTypes: ["Gospodarstwo / Producent", "Spółdzielnia", "Firma spożywcza", "Restauracja", "Handel", "Instytucja badawcza", "Organizacja", "Osoba prywatna / Entuzjasta", "Inne"],
    rhubarbTitle: "Twój rabarbar",
    varietiesPh: "Odmiany rabarbaru, które uprawiasz lub z którymi pracujesz",
    areaPh: "Przybliżona powierzchnia upraw (np. 2 ha)",
    productionPh: "Przybliżona roczna produkcja (np. 5 t)",
    consentTitle: "Zgoda na publikację",
    consentAgree: "Zgadzam się na publiczne wyświetlanie wybranych przeze mnie informacji w Globalnej Bazie Danych Rabarbaru.",
    consentDecline: "Nie chcę, aby moje informacje były publicznie wyświetlane.",
    fieldsLabel: "Wybierz, co może zostać opublikowane:",
    fieldLabels: {
      farm_name: "Nazwa gospodarstwa / organizacji", country: "Kraj", region: "Region",
      website: "Strona / media społecznościowe", org_type: "Typ organizacji", varieties: "Odmiany rabarbaru",
      cultivation_area: "Powierzchnia upraw", annual_production: "Roczna produkcja",
    },
    noteNoConsent: "Możesz zarejestrować się i odpowiedzieć na ankietę bez zgody na publikację. Twoje odpowiedzi wesprą badania WRA i nigdy nie zostaną opublikowane.",
    crossBorder: "Rozumiem, że moje dane mogą być przetwarzane przez dostawców usług i serwery poza moim krajem (w tym zagraniczny hosting i usługi e-mail), zgodnie z Polityką prywatności.",
    privateNote: "Twój adres e-mail oraz pola, których nie wybierzesz, nigdy nie są publikowane. W każdej chwili możesz poprosić o korektę, aktualizację, usunięcie publicznego wpisu lub usunięcie danych przez formularz kontaktowy.",
    submit: "Wyślij ankietę",
    submitting: "Wysyłanie…",
    thanks: "Ankieta przyjęta",
    successConsent: "Dziękujemy. Wybrane informacje zostaną zweryfikowane i opublikowane w Globalnej Bazie Danych Rabarbaru.",
    successNoConsent: "Dziękujemy. Twoje odpowiedzi zostały zapisane i pozostaną prywatne.",
    errNotFound: "Nie znaleziono rejestracji o podanym numerze referencyjnym i adresie e-mail. Sprawdź oba pola i spróbuj ponownie.",
    toastOk: "Ankieta wysłana.",
    toastErr: "Wysyłanie nie powiodło się. Spróbuj ponownie.",
    editNote: "Już odpowiadałeś? Ponowne wysłanie zaktualizuje poprzednie odpowiedzi.",
  },
  privacy: {
    kicker: "Polityka prywatności",
    titleA: "Jak traktujemy ", titleAccent: "Twoje dane.",
    updated: "Ostatnia aktualizacja: sierpień 2026",
    intro: "World Rhubarb Association (WRA) to dobrowolna inicjatywa międzynarodowa założona w 2026 roku. Niniejsza polityka wyjaśnia, jakie dane osobowe zbieramy, po co i jak je chronimy.",
    sections: [
      { h: "Jakie informacje zbieramy", body: [
        "Przez formularz rejestracyjny: imię i nazwisko, nazwa gospodarstwa lub organizacji, kraj, region, adres e-mail i typ członkostwa.",
        "Przez dobrowolną ankietę do bazy danych: strona www lub media społecznościowe, typ organizacji, odmiany rabarbaru, przybliżona powierzchnia upraw i przybliżona roczna produkcja.",
        "Nie zbieramy danych osobowych, które nie są potrzebne do rejestracji ani do budowy bazy danych (minimalizacja danych).",
      ]},
      { h: "Cel zbierania danych", body: [
        "Budowa i prowadzenie Globalnej Bazy Danych Rabarbaru.",
        "Kontakt ze strony World Rhubarb Association — np. e-mail powitalny, zaproszenie do ankiety i informacje o sieci.",
        "Zarządzanie członkostwem i odpowiadanie na zapytania.",
      ]},
      { h: "Informacje publiczne i niepubliczne", body: [
        "Nigdy nie publikujemy: adresu e-mail, numeru telefonu, adresu prywatnego ani innych osobistych danych kontaktowych.",
        "Publikujemy wyłącznie za wyraźną zgodą i tylko wybrane przez Ciebie pozycje: nazwa gospodarstwa lub organizacji, kraj, region, strona www lub media społecznościowe, typ organizacji, odmiany rabarbaru, przybliżona powierzchnia upraw i przybliżona roczna produkcja.",
        "Możesz zarejestrować się i wypełnić ankietę bez zgody na jakąkolwiek publikację.",
      ]},
      { h: "Dostawcy usług", body: [
        "Do zarządzania bazą danych i dostarczania e-maili możemy korzystać z dostawców usług (np. hostingu i dostarczania poczty) w niezbędnym zakresie. Dostawcy działają na odpowiednich warunkach przetwarzania danych.",
      ]},
      { h: "Przetwarzanie międzynarodowe", body: [
        "WRA obsługuje producentów i zainteresowanych na całym świecie. Twoje dane mogą być przetwarzane przez usługi i serwery poza Twoim krajem, co może stanowić transfer transgraniczny w rozumieniu japońskiej ustawy o ochronie danych osobowych (APPI) i podobnych przepisów.",
        "Wysyłając formularz, potwierdzasz takie przetwarzanie międzynarodowe. Tam, gdzie wymaga tego prawo, przed przekazaniem danych osobowych zagranicznemu podmiotowi uzyskamy odrębną zgodę.",
      ]},
      { h: "Zarządzanie danymi", body: [
        "Dane osobowe są bezpiecznie przechowywane. Dostęp mają wyłącznie członkowie zespołu fundatorskiego WRA, a panel administracyjny jest chroniony hasłem.",
      ]},
      { h: "Korekta, aktualizacja i usunięcie", body: [
        "W każdej chwili możesz poprosić o korektę danych, aktualizację, usunięcie publicznego wpisu lub usunięcie danych — przez formularz kontaktowy na stronie głównej. Odpowiadamy niezwłocznie po weryfikacji tożsamości.",
      ]},
      { h: "Kontakt", body: [
        "W sprawach prywatności prosimy o kontakt przez formularz na stronie głównej.",
      ]},
    ],
  },
};
